import MDBox from "components/MDBox";

import MDButton from "components/MDButton";

import DataTable from "examples/Tables/DataTable";
import React, { useState, useEffect } from "react";
import { CircularProgress, Icon, Tooltip } from "@mui/material";
import PropTypes from "prop-types";

import ComponentsPrivatization from "config/component_privatization";
import { style_icon } from "helpers/global_vars";
import {
  AUXILIAR_DOCENTE,
  COORDINADOR_DOCENTE,
  FIRMANTE_TITULOS,
  FIRMANTE,
} from "roles";
import usePagination from "hooks/usePagination";
import { handleToast } from "../../../../helpers/handleToast";
import NewTitulo from "../../ModalCreate/NewTitulo/newTitulo";
import CheckBox from "../../../../components/CheckBox";
import ModalFirmar from "../../../../components/ModalFirmar";
import { FiltersComponentCarpeta } from "../cursos/carpetasFiltros";
import { useGetTagsQuery } from "services";
import { useSnackbar } from "notistack";

// Importamos los hooks de los endpoints recién creados
import {
  useGetTitulosQuery,
  useDeleteTituloMutation,
} from "../../../../services/escuela/titulos";

function DataTableTitulos({ tableHeader }) {
  const [openModal, setOpenModal] = useState(false);
  const [openModalFirmar, setOpenModalFirmar] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [checkedAll, setCheckedAll] = useState(false);
  const [carpeta, setCarpeta] = useState("");
  const { enqueueSnackbar } = useSnackbar();

  // Manejo de paginación y búsqueda
  const {
    offset,
    setOffset,
    limit,
    busqueda,
    setBusqueda,
    handleNext,
    handlePrevious,
  } = usePagination();

  // Consulta GET
  const {
    data: titulos_data,
    isError: isErrorG,
    isLoading: isLoadingG,
    error: errorG,
    isFetching,
  } = useGetTitulosQuery(
    {
      filter_params: {
        buscar: busqueda,
        limit: limit,
        offset: offset,
        tags: carpeta,
      },
      shape: {
        id: "id",
        estudiante: "estudiante",
        estado: "estado",
        unique_str: "unique_str",
        sello: "sello",
        firmante_url: "firmante",
      },
    },
    {
      refetchOnReconnect: true,
      refetchOnMountOrArgChange: true,
    },
  );

  const { data: carpetas, isLoading: isLoadingCarp } = useGetTagsQuery();

  // Consulta DELETE
  const [
    deleteTitulo,
    {
      isSuccess: isSuccessD,
      isLoading: isLoadingD,
      isError: isErrorD,
      error: errorD,
    },
  ] = useDeleteTituloMutation();

  // Constantes para manejar la paginación
  const titulos = titulos_data?.results ? titulos_data.results : titulos_data;
  const countTotal = titulos_data?.count;
  const previous = titulos_data?.previous;
  const next = titulos_data?.next;

  const user_info = JSON.parse(sessionStorage.getItem("user") || "{}");
  const myFirmanteUrl = user_info?.perfil?.resourcetype?.find(
    (e) => e.resourcetype === FIRMANTE,
  )?.url;
  const isFirmante = user_info?.groups?.some((e) => e.name === FIRMANTE);
  const isFirmanteTitulos = user_info?.groups?.some(
    (e) => e.name === FIRMANTE_TITULOS,
  );

  useEffect(() => {
    if (!checkedAll) {
      setSelectedItems([]);
    } else {
      setSelectedItems(
        titulos?.filter(
          (el) => !el.sello && el.firmante_url === myFirmanteUrl,
        ) || [],
      );
    }
  }, [checkedAll, titulos, myFirmanteUrl]);

  // Estructura de la tabla
  const dataTableTitulo = {
    columns: [
      {
        Header: () => {
          return isFirmante ? (
            <CheckBox
              id={"No."}
              checked={
                checkedAll &&
                selectedItems.length === (titulos?.length || 0) &&
                titulos?.length > 0
              }
              onChange={() => {
                setCheckedAll(!checkedAll);
              }}
            />
          ) : null;
        },
        accessor: "checkbox",
        width: "10%",
        Cell: ({ row }) => {
          const { original } = row;
          const firmado = !!original.sello;
          const isMyTitulo = original.firmante_url === myFirmanteUrl;
          return isFirmante ? (
            <CheckBox
              disabled={firmado || !isMyTitulo}
              id={Number(row.id) + 1}
              checked={selectedItems.includes(row.original)}
              onChange={() => {
                const el = row.original;
                if (selectedItems.includes(el)) {
                  setSelectedItems((prevItems) =>
                    prevItems.filter((item) => item.id !== el.id),
                  );
                } else {
                  setSelectedItems((prevItems) => [...prevItems, el]);
                }
              }}
            />
          ) : null;
        },
      },
      {
        Header: "ID",
        accessor: "id",
        width: "10%",
        Cell: ({ value }) => {
          return value ? value : "-------------";
        },
      },
      {
        Header: "Estudiante",
        accessor: "estudiante",
        width: "59%",
        Cell: ({ value }) => {
          return value
            ? value.user.apellido_paterno +
                " " +
                value.user.apellido_materno +
                " " +
                value.user.first_name
            : "-------------";
        },
      },
      {
        Header: "Estado",
        accessor: "estado",
        width: "10%",

        Cell: ({ value }) => {
          return value ? value : "-------------";
        },
      },
      {
        Header: "Firma",
        accessor: "sello",
        width: "10%",
        Cell: ({ value }) => {
          return value ? (
            <Tooltip placement="top" title="Título firmado digitalmente">
              <Icon color="success">verified</Icon>
            </Tooltip>
          ) : (
            <Tooltip placement="top" title="Título sin firmar">
              <Icon color="error">unpublished</Icon>
            </Tooltip>
          );
        },
      },
      {
        Header: "Acciones",
        accessor: "actions",
        width: "1%",
        Cell: ({ row }) => {
          const { original } = row;

          return (
            <MDBox display="flex">
              <ComponentsPrivatization
                permitted={[AUXILIAR_DOCENTE, COORDINADOR_DOCENTE]}
              >
                <MDBox px={0.2}>
                  <Tooltip placement="top" title="Editar título">
                    <Icon
                      style={style_icon}
                      onClick={() => {
                        // TODO: Lógica para abrir modal de edición
                        console.log("Editar título con id: ", original.id);
                      }}
                      fontSize="small"
                    >
                      edit
                    </Icon>
                  </Tooltip>
                </MDBox>
              </ComponentsPrivatization>

              <ComponentsPrivatization permitted={[COORDINADOR_DOCENTE]}>
                <MDBox px={0.2}>
                  <Tooltip placement="top" title="Eliminar título">
                    <Icon
                      style={style_icon}
                      onClick={() =>
                        handleToast({
                          title: "¿Estás seguro?",
                          text: `¡Si eliminas este título, la acción no se podrá revertir!`,
                          dispatcher: (result) => {
                            if (result.isConfirmed) {
                              deleteTitulo(original.id);
                            }
                          },
                        })
                      }
                      fontSize="small"
                    >
                      remove_circle
                    </Icon>
                  </Tooltip>
                </MDBox>
              </ComponentsPrivatization>
            </MDBox>
          );
        },
      },
    ],
    rows: titulos ?? [],
  };

  const handleChange = (e) => {
    setCarpeta(e.target.value);
  };

  // Acciones globales (Crear Nuevo, etc)
  const actions = (
    <MDBox display="flex" gap={2} alignItems="center">
      {isFirmante && isFirmanteTitulos ? (
        <ComponentsPrivatization permitted={[FIRMANTE_TITULOS]}>
          <MDBox display={"flex"} gap={1} alignItems={"center"}>
            <MDButton
              variant="gradient"
              color="primary"
              size="medium"
              onClick={() =>
                selectedItems.length === 0
                  ? enqueueSnackbar(
                      "Debe seleccionar en la tabla al menos un estudiante para poder realizar la firma.",
                      { variant: "error", autoHideDuration: 5000 },
                    )
                  : setOpenModalFirmar(true)
              }
            >
              Firmar
            </MDButton>
          </MDBox>
        </ComponentsPrivatization>
      ) : null}
      <ComponentsPrivatization
        permitted={[COORDINADOR_DOCENTE, AUXILIAR_DOCENTE]}
      >
        <MDBox display={"flex"} gap={1} alignItems={"center"}>
          <Tooltip placement="top" title="Crear nuevo título">
            <MDButton
              variant="contained"
              color="accent"
              size="medium"
              onClick={() => {
                setOpenModal(true);
              }}
            >
              nuevo
            </MDButton>
          </Tooltip>
        </MDBox>
      </ComponentsPrivatization>
    </MDBox>
  );

  return (
    <MDBox pt={0} pb={3}>
      <MDBox display="flex" justifyContent={"center"} alignItems={"center"}>
        {isLoadingG || isFetching || isLoadingCarp ? (
          <CircularProgress sx={{ marginBottom: "3rem" }} color="inherit" />
        ) : (
          <DataTable
            tableHeader={tableHeader}
            actions={actions}
            table={dataTableTitulo}
            isSorted={false}
            canSearch
            paginationApi
            countTotal={countTotal}
            next={next}
            previous={previous}
            handleNext={handleNext}
            handlePrevious={handlePrevious}
            setBusqueda={setBusqueda}
            offset={offset}
            setOffset={setOffset}
            filtersComponent={
              <FiltersComponentCarpeta
                carpeta={carpeta}
                handleChange={handleChange}
                carpetas={carpetas}
              />
            }
          />
        )}
      </MDBox>
      <NewTitulo open={openModal} handleClose={() => setOpenModal(false)} />
      {openModalFirmar && (
        <ModalFirmar
          open={openModalFirmar}
          handleClose={() => {
            setOpenModalFirmar(false);
            setSelectedItems([]);
            setCheckedAll(false);
          }}
          selected={selectedItems}
          titulo={true}
        />
      )}
    </MDBox>
  );
}

DataTableTitulos.propTypes = {
  tableHeader: PropTypes.string.isRequired,
};

export default DataTableTitulos;
